export default __webpack_public_path__ + "assets/orgauth-reject.0afac185.png";